const PrintIcon = (width = 24, height = 24, color = '#00675D') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24"><path d="M24 11v12H0V11h4V1h10.328C15.866 1 20 5.852 20 7.031V11h4zM6 16h12V7.604c0-1.338-2.281-1.494-3.25-1.229.453-.813.305-3.375-1.082-3.375H6v13zm16-3h-2v5H4v-5H2v8h20v-8zm-6 0H8v-1h8v1zm0-3H8v1h8v-1zm0-2H8v1h8V8z" fill="${color}"/></svg>
`;
export default PrintIcon;
